import { Component, ElementRef, OnDestroy, ViewChild } from '@angular/core';
import { CacheService } from 'projects/common/src/app/services/cache.service';
import { ParameterHandlerService } from 'projects/common/src/app/services/parameter-handler.service';
import { flatten } from 'projects/common/src/app/services/utils/utilities';
import { BooleanStateService } from 'src/app/modules/core/services/boolean-state.service';
import { MachineContextService } from 'src/app/modules/core/services/parameter/machine-context/machine-context.service';
import { IResponseDumpPoint } from 'src/app/modules/widget/interfaces/dump-points';
import { ScreenViewService } from 'src/app/modules/widget/services/screen-view.service';
import { CommunicationService } from 'src/app/services/communication/communication.service';
import { DashboardWidgetBasicComponent } from '../../dashboard-widget-basic/dashboard-widget-basic.component';

@Component({
  selector: 'app-detail-dump-point',
  templateUrl: './detail-dump-point.component.html',
  styleUrls: ['./detail-dump-point.component.scss'],
})
export class DetailDumpPointComponent extends DashboardWidgetBasicComponent implements OnDestroy {
  @ViewChild('scroll', { static: true })
  public scrollContainer: ElementRef;
  public disableShadowBottom = false;
  public disableShadowTopBottom = true;
  public disableShadowTop = true;
  public widthScrollContainer = 0;

  public dataMachines: IResponseDumpPoint;
  public shifts = [];
  public machineNames = [];
  public dumpPointMapped = [];

  constructor(
    public booleanBarService: BooleanStateService,
    public communication: CommunicationService,
    public parameterService: ParameterHandlerService,
    protected cacheService: CacheService,
    protected machineContext: MachineContextService,
    protected screenViewService: ScreenViewService,
  ) {
    super(booleanBarService, communication, parameterService, cacheService, machineContext, screenViewService);
    this.initRequestParams();
  }

  /**
   * Init request params
   */
  private initRequestParams(): void {
    this.params = {
      hasShift: true,
      hasCompany: true,
      hasDate: true,
      hasMachineType: true,
      hasZone: true,
    };
  }

  /**
   *  buildView Minute by MInute
   *
   * @param values parameter value
   */
  public buildView(values: any): void {
    super.buildView(values);
    this.getPointDump(values);
  }

  /**
   * Get data Point Dump
   */
  public async getPointDump(dataMachines: IResponseDumpPoint): Promise<any> {
    this.dataMachines = dataMachines;

    if (this.dataMachines) {
      const shiftOrder = this.dataMachines.shiftData.map((order) => {
        return { shiftId: order.shiftId, shiftOrder: order.shiftOrder };
      });

      this.dataMachines.productionByDumpPoint.forEach((prod) => {
        let orderedShift = [];

        shiftOrder.forEach((element) => {
          const prodByShift = prod.dumpPointList.find((shift) => shift.shiftId === +element.shiftId);
          orderedShift = [...orderedShift, prodByShift];
        });
        prod.dumpPointList = orderedShift;
      });

      this.machineNames = this.dataMachines.productionByDumpPoint[0].dumpPointList.map((shift) => {
        return shift.dumpPointMachineModel.map((machine) => {
          return { machine: machine.machineModelName, shift: shift.shiftName };
        });
      });

      this.dumpPointMapped = this.dataMachines.productionByDumpPoint.map((production) => {
        const { zoneName } = production;

        const productionByDump = production.dumpPointList.map((prodByDump) => {
          return prodByDump.dumpPointMachineModel.map((machine) => {
            return machine.productionByDumpPoint;
          });
        });
        return [zoneName, productionByDump, flatten(productionByDump).reduce((a, b) => a + b)];
      });

      const allZeros = this.dumpPointMapped.every((entry) => entry[1].every((innerArray) => innerArray.every((value) => value === 0)));
      if (allZeros) {
        this.chartWithoutData$.next(true);
      } else this.chartWithoutData$.next(false);
    }
  }

  /**
   * On scroll component
   */
  public onScroll(): void {
    const element = this.scrollContainer.nativeElement;
    const atBottom = Math.floor(element.scrollWidth - element.scrollLeft) === element.clientHeight;
    const atTop = element.scrollLeft === 0;

    if (atTop && !atBottom) {
      this.disableShadowBottom = false;
      this.disableShadowTop = true;
      this.disableShadowTopBottom = true;
    } else if (!atTop && !atBottom) {
      this.disableShadowBottom = true;
      this.disableShadowTop = true;
      this.disableShadowTopBottom = false;
    } else if (!atTop && atBottom) {
      this.disableShadowBottom = true;
      this.disableShadowTop = false;
      this.disableShadowTopBottom = true;
    }
  }

  /**
   * On Destroy
   */
  public ngOnDestroy(): void {
    super.ngOnDestroy();
  }
}
